"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var billing;
        (function (billing) {
            var confirmInvoice;
            (function (confirmInvoice) {
                class InitArgs {
                    constructor() {
                        this.hasValidCardLoaded = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                confirmInvoice.init = init;
                function addEvents() {
                    $('.btn-success').click(function (e) {
                        e.preventDefault();
                        $(this).prop('disabled', true);
                        $('.loadingScreen .loading-headertext').text(_initArgs.hasValidCardLoaded);
                        $('.loadingScreen .loading-subtitletext').text('Please do not refresh or close this page');
                        appn.dialog.showLoading();
                        $('form#appnForm').submit();
                    });
                }
            })(confirmInvoice = billing.confirmInvoice || (billing.confirmInvoice = {}));
        })(billing = views.billing || (views.billing = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
